import { useState } from "react";

import {
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger
} from "@/components/ui/context-menu";
import { Input } from "@/components/ui/input";

type Direction = "top" | "right" | "bottom" | "left";

const directions: Array<{ key: Direction; label: string }> = [
  { key: "top", label: "بالا" },
  { key: "right", label: "راست" },
  { key: "bottom", label: "پایین" },
  { key: "left", label: "چپ" }
];

const parsePixels = (value: string) => {
  const parsedValue = Number.parseInt(value, 10);
  return Number.isNaN(parsedValue) ? 0 : parsedValue;
};

const TablePadding: React.FC<
  React.ComponentProps<"div"> & {
    rightClickedElement: HTMLElement;
  }
> = ({ rightClickedElement }) => {
  const container = rightClickedElement.parentElement as HTMLDivElement;
  const computedStyle = getComputedStyle(container);
  const [padding, setPadding] = useState<Record<Direction, number>>({
    top: parsePixels(computedStyle.paddingTop),
    right: parsePixels(computedStyle.paddingRight),
    bottom: parsePixels(computedStyle.paddingBottom),
    left: parsePixels(computedStyle.paddingLeft)
  });

  const updatePadding = (direction: Direction, value: string) => {
    const nextValue = Math.min(
      500,
      Math.max(0, Number.parseInt(value, 10) || 0)
    );

    setPadding((prev) => ({ ...prev, [direction]: nextValue }));
    container.style.setProperty(`padding-${direction}`, `${nextValue}px`);
  };

  return (
    <ContextMenuSub>
      <ContextMenuSubTrigger>فاصله</ContextMenuSubTrigger>
      <ContextMenuSubContent className="w-72 space-y-1 p-1">
        {directions.map((direction) => (
          <div
            key={direction.key}
            title={`پدینگ ${direction.label}`}
            className="hover:bg-muted/60 grid grid-cols-[48px_62px_1fr] items-center gap-1 rounded-sm px-1 py-1"
          >
            <span className="text-muted-foreground text-[11px]">
              {direction.label}
            </span>
            <Input
              type="number"
              className="h-7 px-2 text-xs"
              min={0}
              max={500}
              step={1}
              value={padding[direction.key]}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => updatePadding(direction.key, e.target.value)}
            />
            <Input
              type="range"
              className="h-4 border-none p-0"
              min={0}
              max={500}
              step={1}
              value={padding[direction.key]}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => updatePadding(direction.key, e.target.value)}
            />
          </div>
        ))}
      </ContextMenuSubContent>
    </ContextMenuSub>
  );
};

export default TablePadding;
